<div class="modal-header modalHeaderBlack">
  <h6 class="modal-title"> {{ "AppointmentListPage.appointmentRemarks" | translate }}</h6>
  <span aria-label="Close" class="close" (click)="onNoClick()" data-automation-attribute="span-close-dialog">
    <mat-icon matTooltip="{{ 'AddInternalNotes.close' | translate }}">clear</mat-icon>
  </span>
</div>

<div>
  <div style="margin: 7px;">
    <div>
      <mat-grid-list cols="8" rowHeight="60px" style="margin-top: 10px;" >
        <mat-grid-tile [colspan]='7' [rowspan]='1'>
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>{{ "AppointmentListPage.addremarks" | translate }}</mat-label>
            <input matInput type="text" name="notes" [(ngModel)]="remarks" [placeholder]="'AppointmentListPage.addremarks' | translate" pattern="[a-zA-Z0-9\s]+" >
          </mat-form-field>
        </mat-grid-tile>
      
  
        <mat-grid-tile [colspan]='1' [rowspan]='1'>
          <button
          mat-mini-fab
          class="btnCyan"
          type="button"
          data-automation-attribute="button-save-dialog"
          matTooltip="{{ 'AddInternalNotes.addRemark' | translate }}" 
          (click)="onAddRemarkClick()"
        >
          <mat-icon>done</mat-icon>
        </button>
        &nbsp;&nbsp;
        <button
          mat-mini-fab
          class="btnRed"
          type="button"
          data-automation-attribute="button-cancel-dialog"
          matTooltip="{{ 'payerInfo.clear' | translate }}" 
          (click)="onNoClick()"
        >
          <mat-icon>close</mat-icon>
        </button>
         
        </mat-grid-tile>
      </mat-grid-list>
    </div>
    <div class="divTableSearchResult tableHeight mat-elevation-z8">
  <table mat-table [dataSource]="remarkSource" matSort>

    <!-- Notes Column -->
    <ng-container matColumnDef="notes">
      <th mat-header-cell *matHeaderCellDef>
        {{ "AppointmentListPage.remarks" | translate }}
      </th>
      <td
        mat-cell
        *matCellDef="let element"
        class="notes-cell"
        [matTooltip]="element.remark"
      >
        {{ element.remark }}
      </td>
    </ng-container>

    <!-- Added By Column -->
    <ng-container matColumnDef="addedBy">
      <th mat-header-cell *matHeaderCellDef>
        {{ "billing.addedBy" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.addedBy }}
      </td>
    </ng-container>

    <!-- Added On Column -->
    <ng-container matColumnDef="noteDate">
      <th mat-header-cell *matHeaderCellDef>
        {{ "billing.addedOn" | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.noteDate | date: 'dd/MM/yyyy hh:mm a' }}
      </td>
    </ng-container>

    <tr
      mat-header-row
      *matHeaderRowDef="remarkColumns; sticky: true"
      class="modalHeaderGreen"
    ></tr>
    <tr mat-row *matRowDef="let row; columns: remarkColumns"></tr>

  </table>
</div>
  </div>
</div>